import React, { useEffect } from 'react';
import { Form, Modal, Button, Row, FormInstance } from 'antd';

import { IRate } from '../../../models';
import { IdInput, TextInput } from '../../atom/form';
import { useScreenSize } from '../../../hooks';
import { ActionDefinition, ModalState, renderActionButtons } from '../crud/new-crud-modal';

export type NewChangeOfferModalProps = {
  form: FormInstance;
  saving: boolean;
  actions: ActionDefinition<IRate>[];
  modalState: ModalState;
  setModalState: (state: ModalState) => void;
};

export function NewChangeOfferModal(props: NewChangeOfferModalProps) {
  const isSmallScreen = useScreenSize();

  const closeModal = () => {
    props.setModalState(ModalState.Hidden);
  };

  useEffect(
    function onLoad() {
      props.form.resetFields();
    },
    [props.modalState],
  );

  const renderEditMode = () => {
    return (
      <>
        <Form form={props.form} layout="vertical">
          <IdInput />
          <TextInput name="code" label="Code" required disabled={props.saving} />
        </Form>
      </>
    );
  };

  return (
    <Modal
      title="Change partner code"
      visible={props.modalState !== ModalState.Hidden}
      onCancel={() => {
        closeModal();
      }}
      footer={
        <Row justify="space-between">
          <Row>
            <Button onClick={closeModal}>Close</Button>
          </Row>
          <Row>{renderActionButtons({} as any, props.actions)}</Row>
        </Row>
      }
      width={720}
      wrapClassName={isSmallScreen ? 'fullscreen' : ''}
      className={props.modalState === ModalState.View ? 'read-mode' : ''}
    >
      {renderEditMode()}
    </Modal>
  );
}
